import React from "react";
import { Modal } from "react-bootstrap";
import AddBankAccount from "../../../bankAccount/components/AddBankAccount";

const PaymentMethodSelectionModal = ({
  title,
  show,
  updateModalShow,
  resetValues,
  bankAccounts,
  setSelectedBankAccount,
  setAutoPaymentBank,
  getAllBankAccounts,
  setLoading,
  selectedBankAccount,
  callbackFunction,
}) => {
  return (
    <Modal
      show={show}
      onHide={() => {
        resetValues();
        updateModalShow(false);
      }}
      className="modal-style-1 w-100"
      size="md"
    >
      <Modal.Header>
        <Modal.Title as="h3" className="w-100 text-center">
          {title}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="accordion accordion-flush accordion-v2">
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingTwo">
              <button
                className="accordion-button collapsed schedule-date-btn"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
                data-cy="payfrom"
              >
                Pay From
              </button>
            </h2>
            <div
              id="collapseTwo"
              className="accordion-collapse"
              aria-labelledby="headingTwo"
              data-bs-parent="#accordion1"
            >
              <div className="accordion-body">
                <div className="select">
                  <select
                    data-cy="bankaccount"
                    defaultValue={
                      bankAccounts?.find((item) => item?.default_bank_account === 1)
                        ? JSON.stringify(bankAccounts.find((item) => item?.default_bank_account === 1))
                        : "hide"
                    }
                    onChange={(e) => {
                      e.preventDefault();
                      if (e.target.value) {
                        setSelectedBankAccount(JSON.parse(e.target.value));
                        //setAutoPaymentBank();
                      }
                    }}
                  >
                    <option disabled value="hide">
                      {bankAccounts.length > 0 ? "Select Bank Account" : "You have not added any bank account"}
                    </option>

                    {bankAccounts
                      ?.filter((bank) => bank.status !== "pending_manual_verification")
                      ?.map((bank, index) => (
                        <option key={index} value={JSON.stringify(bank)}>
                          **** **** **** {bank?.account_number}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="text-center py-3 fw-bold">or</div>
                <AddBankAccount
                  getAllBankAccounts={getAllBankAccounts}
                  setLoading={setLoading}
                  isFromDashboard={true}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>

      <div className="row modal-btns">
        <div className="col-6">
          <button
            type="button"
            className="btn btn-warning w-100"
            onClick={() => {
              resetValues();
              updateModalShow(false);
            }}
          >
            Cancel
          </button>
        </div>
        <div className="col-6">
          <button
            disabled={!selectedBankAccount}
            onClick={() => {
              callbackFunction();
              updateModalShow(false);
            }}
            type="button"
            className="btn btn-primary w-100"
            data-cy="continue"
          >
            Continue
          </button>
        </div>
      </div>
    </Modal>
  );
};
export default PaymentMethodSelectionModal;
